import React, { useState } from 'react';
 
const Header = () => {
  // 1. Create a state to track whether the mobile menu is open
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // 2. Toggle function for the hamburger button
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      <header className="digi-header-floating px-3 px-md-5 pt-4">
        <div className="digi-nav-container d-flex align-items-center justify-content-between position-relative">
          <div className="digi-logo d-flex align-items-center">
            <a href="/">
              <img
                src="/images/logo-khult.png"
                alt="Logo"
                className="img-fluid"
                style={{ maxHeight: 50, width: "auto" }}
              />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="digi-nav-links d-none d-lg-flex align-items-center gap-4">
            <a className="nav-txt-link active" href="/">Home</a>
            <a className="nav-txt-link" href="about-us">About Us</a>
            {/* ... keeping your existing dropdowns exactly as they were ... */}
            <div className="dropdown">
              <a
                className="nav-txt-link dropdown-toggle"
                href="#"
                role="button"
                id="photographyDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Photography Services
              </a>
              <ul className="dropdown-menu custom-digi-dropdown" aria-labelledby="photographyDropdown">
                <li><a className="dropdown-item" href="/pre-wedding-and-wedding-photography">Pre Wedding and Wedding</a></li>
                <li><a className="dropdown-item" href="/modelling-and-acting-photography">Modelling And Acting</a></li>
                <li><a className="dropdown-item" href="/commercial-and-industrial-photography">Commercial and Industrial</a></li>
                <li><a className="dropdown-item" href="/fashion-and-beauty-photography">Fashion and Beauty</a></li>
                <li><a className="dropdown-item" href="/products-and-brands-photography">Products and Brands</a></li>
                <li><a className="dropdown-item" href="/events-and-celebrations-photography">Events and Celebrations</a></li>
                <li><a className="dropdown-item" href="/creative-and-arts-photography">Creative and Arts</a></li>
                <li><a className="dropdown-item" href="/maternity-and-baby-photography">Maternity and Baby</a></li>
                <li><a className="dropdown-item" href="/love-and-family-photography">Love and Family</a></li>
                <li><a className="dropdown-item" href="/celebrity-and-movie-posters">Celebrity and Movie Posters</a></li>
              </ul>
            </div>
            <div className="dropdown">
              <a
                className="nav-txt-link dropdown-toggle"
                href="#"
                role="button"
                id="portfolioDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Portfolios
              </a>
              <ul className="dropdown-menu custom-digi-dropdown" aria-labelledby="portfolioDropdown">
                <li><a className="dropdown-item" href="/acting-photography-portfolio">Acting Photography</a></li>
                <li><a className="dropdown-item" href="/child-photography-portfolio">Child Photography</a></li>
                <li><a className="dropdown-item" href="/wedding-photography-portfolio">Wedding Photography</a></li>
                <li><a className="dropdown-item" href="/product-photography-portfolio">Product Photography</a></li>
                <li><a className="dropdown-item" href="/fashion-photography-portfolio">Fashion Photography</a></li>
                <li><a className="dropdown-item" href="/interior-photography-portfolio">Interior Photography</a></li>
                <li><a className="dropdown-item" href="/corporate-photography-portfolio">Corporate Photography</a></li>
              </ul>
            </div>
            <a className="nav-txt-link" href="/image-gallery">Image Gallery</a>
            <a className="nav-txt-link" href="/video-gallery">Video Gallery</a>
            <a className="nav-txt-link" href="/career">Career</a>
            <a className="nav-txt-link" href="/contact-us">Contact Us</a>
          </nav>

          {/* 3. Dynamic Class: Appends 'open' or 'show' depending on state */}
          <div
            className={`mobile-drawer-menu ${isMenuOpen ? 'open' : ''}`}
            id="mobileDrawer"
          >
            <a className="mobile-nav-link" href="#home" onClick={toggleMenu}>Home</a>
            <a className="mobile-nav-link" href="#about" onClick={toggleMenu}>About Us</a>

            <div className="mobile-services-heading">Photography Services:</div>
            <a className="mobile-nav-link ps-4 sub-link" href="/pre-wedding-and-wedding-photography" onClick={toggleMenu}>- Wedding Photography</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/modelling-and-acting-photography" onClick={toggleMenu}>- Modeling & Acting</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/commercial-and-industrial-photography" onClick={toggleMenu}>- Commercial & Industrial</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/fashion-and-beauty-photography" onClick={toggleMenu}>- Fashion & Beauty</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/products-and-brands-photography" onClick={toggleMenu}>- Product & Brand</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/events-and-celebrations-photography" onClick={toggleMenu}>- Event & Celebration</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/creative-and-arts-photography" onClick={toggleMenu}>- Creative & Fine Art</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/maternity-and-baby-photography" onClick={toggleMenu}>- Maternity & Baby</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/love-and-family-photography" onClick={toggleMenu}>- Love & Family</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/celebrity-and-movie-posters" onClick={toggleMenu}>- Celebrity & Movie Poster</a>

           <div className="mobile-services-heading">Portfolios </div>
           <a className="mobile-nav-link ps-4 sub-link" href="/acting-photography-portfolio" onClick={toggleMenu}>- Acting Photography</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/child-photography-portfolio" onClick={toggleMenu}>- Child Photography</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/wedding-photography-portfolio" onClick={toggleMenu}>- Wedding Photography</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/product-photography-portfolio" onClick={toggleMenu}>- Product Photography</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/fashion-photography-portfolio" onClick={toggleMenu}>- Fashion Photography</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/interior-photography-portfolio" onClick={toggleMenu}>- Interior Photography</a>
            <a className="mobile-nav-link ps-4 sub-link" href="/corporate-photography-portfolio" onClick={toggleMenu}>- Corporate Photography</a>

            <a className="mobile-nav-link" href="/career" onClick={toggleMenu}>Career</a>
            <a className="mobile-nav-link" href="/contact-us" onClick={toggleMenu}>Contact Us</a>
          </div>

          <div className="digi-nav-actions d-flex align-items-center gap-3">
            <div className="call-badge-wrapper d-none d-sm-flex align-items-center gap-2">
              <div className="orange-circle-icon">
                <i className="fa-solid fa-phone-flip" />
              </div>
              <div className="call-meta-text">
                <span className="label">Contact Us </span>
                <span className="phone-number">+918897866074 </span>
              </div>
            </div>

            {/* 4. Added onClick listener and open class to hamburger button */}
            <button
              className={`mobile-hamburger-btn ms-2 ${isMenuOpen ? 'open' : ''}`}
              id="mobileMenuBtn"
              type="button"
              aria-label="Toggle Navigation"
              onClick={toggleMenu}
            >
              <span className="bar-line" />
              <span className="bar-line" />
              <span className="bar-line" />
            </button>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;